<section>
  <div class="content-2 bg-gray-100">
    <div class="title-container">
      <h1 class="text-blue-500 text-heading-lg text-bold m-0 mb-2">Projeção da oferta de matrículas por escola</h1>
      <h2 class="text-charcoal-800 text-body-xlg text-regular m-0">Informe o número de matrículas a ser ofertado em cada escola.</h2>
    </div>

    <hr class="division-line" />

    <div *ngIf="projecoes.length > 0" class="busca-container">
      <input
        type="text"
        class="busca-escola"
        [(ngModel)]="termoBusca"
        (ngModelChange)="aplicarFiltro()"
        placeholder="Buscar escola pelo nome"
        aria-label="Buscar escola pelo nome"
      />
    </div>

    <div
      *ngIf="projecoes.length > 0"
      #listaContainer
      class="expansion-panels-container schools-viewport"
    >
      <app-escola
        *ngFor="let projecao of projecoesFiltradas; trackBy: trackByEscola"
        #escolaAnchor
        [projecao]="projecao"
        [expandido]="escolaAbertaId === projecao.codMec"
        (expandidoChange)="aoAlternarEscola($event, projecao)">
      </app-escola>

      <p *ngIf="projecoesFiltradas.length === 0" class="sem-resultados">
        Nenhuma escola encontrada para "{{ termoBusca }}".
      </p>
    </div>
  </div>
</section>
